// extracted by mini-css-extract-plugin
export default {"closeIcon":"closeIcon--mIen7"};